










































import { Component, Vue } from 'vue-property-decorator';
import Modal from '@/main-components/common/modal/Modal.vue';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import cookie, { COOKIE } from '@/utils/cookie';
import MainButton from '@/main-components/common/MainButton.vue';

@Component({
  components: {
    Modal,
    MainButton,
  },
})
export default class ModalCareer extends Vue {
  userStore: UserStoreInterface = UserStore;

  openModal: any = null;
  closeModal: any = null;

  workOptions = [
    {
      id: 'Marketing Manager',
      value: 'Marketing Manager',
    },
    {
      id: 'Software Engineer',
      value: 'Software Engineer',
    },
    {
      id: 'Entrepreneur',
      value: 'Entrepreneur / Business Owner',
    },
    {
      id: 'Doctor / Nurse / Caretaker',
      value: 'Doctor / Nurse / Caretaker',
    },
    {
      id: 'Lawyer',
      value: 'Lawyer',
    },
  ];

  customCareer = '';
  selectedCareer = '';

  async submitCareer() {
    await this.userStore.postReview(this.customCareer || this.selectedCareer);

    if (this.userStore.error) {
      return { error: this.userStore.error };
    } else {
      this.$toasted.global.mainToast({
        message: 'Thank you. Your response has been submitted.',
      });

      cookie.set(COOKIE.HAS_REVIEWED, 'true', { sameSite: 'strict' });
      this.$sendMpEvent({ event: this.$mp_value.CareerSubmit });

      this.closeModal && this.closeModal();
    }
  }

  selectionCareerClick(selectedValue: string) {
    this.selectedCareer = selectedValue;
  }

  mounted() {
    this.$emit('openModalCareer', this.openModal);
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
